import { setIsTooltipOpen } from '../../../shared/actions/flatTourBooking';
import { transformUserBookingStatus } from '../../../shared/mappers/transformUserBookingStatus';
import {
  fetchAddFlatTourBooking,
  IAddFlatTourBookingResponse200,
  IAddFlatTourBookingResponse400,
  IAddFlatTourBookingRequest,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/add-flat-tour-booking';
import { IThunkActionCreator } from '../../../shared/store';

export function addFlatTourBooking(parameters: IAddFlatTourBookingRequest): IThunkActionCreator {
  return async (dispatch, getState, { httpApi, logger }): Promise<void> => {
    try {
      const response = await fetchAddFlatTourBooking<IAddFlatTourBookingResponse200, IAddFlatTourBookingResponse400>({
        httpApi,
        parameters,
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
          },
        },
      });

      if (response.statusCode !== 200) {
        throw response.response.message;
      }

      const flatViewOrder = transformUserBookingStatus(response.response.userBookingStatus);
      dispatch({ payload: flatViewOrder, type: 'IFlatViewOrderUpdated' });
      dispatch(setIsTooltipOpen(true));
    } catch (error) {
      logger.error(error, {
        domain: 'addFlatTourBooking',
      });
      throw error;
    }
  };
}
